"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onWalletAmountMessageBannerClick = exports.WalletAmountMessageBanner = void 0;
var _icons = require("@ori-ui/icons");
var _auth = require("@ori/auth");
var _culture = require("@ori/culture");
var _presentationHooks = require("@ori/presentation-hooks");
var _presentationUtils = require("@ori/presentation-utils");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _useTranslations = require("../../hooks/useTranslations");
var _styles = require("../SponsorInfo/styles");
var _constants = require("./constants");
var _hooks = require("./hooks");
var _styles2 = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const onWalletAmountMessageBannerClick = () => {
  window.location.href = (0, _presentationUtils.addSecondaryLanguageToPathname)('/mypages/wallet/', window.location.pathname);
};
exports.onWalletAmountMessageBannerClick = onWalletAmountMessageBannerClick;
const WalletAmountMessageBanner = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    customerId
  } = (0, _auth.useToken)();
  const {
    culture,
    financialSet
  } = (0, _culture.useCulture)();
  const {
    translations
  } = (0, _useTranslations.useTranslations)();
  const availableBalance = (0, _hooks.useGetAvailableBalance)();
  const {
    open,
    onClose
  } = (0, _presentationHooks.useDisclose)({
    defaultOpen: true
  });
  const onBannerClose = (0, _react.useCallback)(e => {
    e.stopPropagation();
    window.localStorage.setItem(_constants.WALLET_AMOUNT_MESSAGE_BANNER_LOCAL_STORAGE_KEY, String(customerId));
    onClose();
  }, [customerId, onClose]);
  if (availableBalance < 1 || !open) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles2.Root, {
    "data-testid": getTestId(_constants.WALLET_AMOUNT_MESSAGE_BANNER),
    "aria-label": translations.oriflameWallet,
    onClick: onWalletAmountMessageBannerClick,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles2.Icon, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.WalletFilled, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.InnerText, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SponsorTextTopRow, {
        variant: "overline",
        children: translations.oriflameWallet
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SponsorTextBottomRow, {
        "data-testid": getTestId(_constants.WALLET_AMOUNT_MESSAGE_BANNER_AMOUNT),
        children: (0, _culture.formatCurrency)(availableBalance, culture, financialSet)
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ClearIcon, {
      "data-testid": getTestId(_constants.WALLET_AMOUNT_MESSAGE_BANNER_CLOSE_ICON),
      "aria-label": translations.close,
      onClick: onBannerClose,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Clear, {})
    })]
  });
};
exports.WalletAmountMessageBanner = WalletAmountMessageBanner;